import { render, staticRenderFns } from "./CoachChat.vue?vue&type=template&id=df60f616&scoped=true&"
import script from "./CoachChat.vue?vue&type=script&lang=js&"
export * from "./CoachChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df60f616",
  null
  
)

export default component.exports